import { toaster } from "../components/toaster";
import { DefaultService } from "../generated";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const useInvoiceUpdate = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ["invoiceUpdate"],
    mutationFn: DefaultService.fakturInvoicesViewsInvoiceUpdate,
    onSuccess: () => {
      toaster.success({ title: "Faktura oppdatert!" });
      queryClient.invalidateQueries({ queryKey: ["invoiceDetail"] });
      queryClient.invalidateQueries({ queryKey: ["invoiceList"] });
    },
  });
};
